import React, { useEffect, useState, memo } from 'react';
import './load-container.scss';
import { CircularProgress } from '@material-ui/core';
import { AppNumConstants } from 'constants/app-num-constants.enum';
import { LoadContainerProps } from './load-container-props';

/**
 * Displays a loading indicator after a delay if the loading prop is true,
 * otherwise render the children.
 * @param props
 */
export const LoadContainer: React.FC<LoadContainerProps> = memo((props) => {
  const {
    loading,
    loadComponent = <CircularProgress />,
    delay = AppNumConstants.LoadIndicatorDelay,
    children,
  } = props;

  const [displayLoading, setDisplayLoading] = useState(false);

  /**
   * Only display the loading spinner after a short delay.
   */
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (loading) {
        setDisplayLoading(true);
      }
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [delay, loading]);

  return (
    <>
      {loading && displayLoading && (
        <div className="sg-load-container">
          {loadComponent}
        </div>
      )}
      {!loading && children}
    </>
  );
});

/* (LoadContainer as any).whyDidYouRender = {
  customName: 'LoadContainer',
};
 */
